import type { WarpGrepProvider } from '../../providers/types.js';

function isValidRange(start: unknown, end: unknown): boolean {
  return (
    typeof start === 'number' &&
    typeof end === 'number' &&
    Number.isFinite(start) &&
    Number.isFinite(end) &&
    start > 0 &&
    end >= start
  );
}

export async function toolRead(
  provider: WarpGrepProvider,
  args: { path: string; start?: number; end?: number; lines?: Array<[number, number]> }
): Promise<string> {
  if (args.lines && Array.isArray(args.lines) && args.lines.length > 0) {
    const validRanges: Array<[number, number]> = [];
    for (const range of args.lines) {
      if (Array.isArray(range) && range.length >= 2 && isValidRange(range[0], range[1])) {
        validRanges.push([range[0], range[1]]);
      }
    }
    
    if (validRanges.length === 0) {
      const res = await provider.read({ path: args.path });
      if (res.error) return res.error;
      if (!res.lines.length) return '(empty file)';
      return res.lines.join('\n');
    }
    
    const chunks: string[] = [];
    for (const [start, end] of validRanges) {
      const res = await provider.read({ path: args.path, start, end });
      if (res.error) return res.error;
      chunks.push(res.lines.join('\n'));
    }
    if (chunks.every(c => c === '')) return '(empty file)';
    return chunks.join('\n...\n');
  }

  const res = await provider.read({ path: args.path, start: args.start, end: args.end });
  if (res.error) {
    return res.error;
  }
  if (!res.lines.length) return '(empty file)';
  return res.lines.join('\n');
}

